import { useTranslation } from "react-i18next";
import CardIconWithText from "../../components/other/CardIconWithText";
import useLogout from "../../hooks/useLogout";
import { isAppTesting } from "../../helpers/methods";
import { APP_STAGE_BAR_HEIGHT } from "../../helpers/constants";
import { Grid } from "@mui/material";



export default function HomePage() {
  const { t } = useTranslation();
  const { handleLogout } = useLogout();

  const marginTop = isAppTesting() ? APP_STAGE_BAR_HEIGHT : "0px";

  return (

        <Grid container spacing={3}
        sx={{
                  height: `calc(100vh - ${marginTop})`
         }}>

          <Grid item xs={12}>
            <CardIconWithText
              cardAreaStyle={{
                height: "10vh",
                alignItems: "center",
                textAlign: "center",
                padding: "5px"
              }}
              label={t("page.home_page.logout")}
              icon={"LogoutIcon"}
              isSelected={true}
              onClick={handleLogout}
            />
          </Grid>
        </Grid>

  );
}
